import { createAsyncActionType } from '../async';

/* Internal */

export const SAGA_STATUS_BEGIN = '@@sagaStatus/SAGA_STATUS_BEGIN';
export const SAGA_STATUS_ERROR = '@@sagaStatus/SAGA_STATUS_ERROR';
export const SAGA_STATUS_FINISH = '@@sagaStatus/SAGA_STATUS_FINISH';

/* App Ui Actions */

export const MODAL_CLOSE = '@@app/MODAL_CLOSE';
export const MODAL_OPEN = '@@app/MODAL_OPEN';

export const TOOLTIP_CLOSE = '@@app/TOOLTIP_CLOSE';
export const TOOLTIP_OPEN = '@@app/TOOLTIP_OPEN';

export const SPINNER_CLOSE = '@@app/SPINNER_CLOSE';
export const SPINNER_OPEN = '@@app/SPINNER_OPEN';

export const LOCALIZATION_LOADED = '@@app/LOCALIZATION_LOADED';
export const LOCALIZATION_SELECT = '@@app/LOCALIZATION_SELECT';
export const LOCALIZATION_SELECT_APPLY = '@@app/LOCALIZATION_SELECT_APPLY';

export const ERROR_PAGE_SET_ERROR = '@@app/ERROR_PAGE_SET_ERROR';
export const LAYOUT_SET_ERROR = '@@app/LAYOUT_SET_ERROR';

export const SET_BAD_REQUEST_ERROR = '@@app/SET_BAD_REQUEST_ERROR';
export const CLEAR_BAD_REQUEST_ERROR = '@@app/CLEAR_BAD_REQUEST_ERROR';

export const SET_GLOBAL_COMPONENTS = '@@app/SET_GLOBAL_COMPONENTS';
export const CLEAR_GLOBAL_COMPONENTS = '@@app/CLEAR_GLOBAL_COMPONENTS';

export const WIZARD_SET_SECTION = '@@wizard/WIZARD_SET_SECTION';
export const WIZARD_CLEAN_DATA = '@@wizard/WIZARD_CLEAN_DATA';
export const WIZARD_UPDATE_DATA = '@@wizard/WIZARD_UPDATE_DATA';

/* OPT */

export const SET_OTP = '@@otp/SET_OTP';

/* Static Values Actions */

export const STATIC_VALUES_GET = createAsyncActionType('static', 'STATIC_VALUES_GET');

/* User Actions */

export const USER_ROLES = createAsyncActionType('user', 'USER_ROLES');
export const USER_LOAD = createAsyncActionType('user', 'USER_LOAD');
export const USER_UPDATE = '@@user/USER_UPDATE';
export const USER_CREATE_NEW_POST = createAsyncActionType('users', 'USER_CREATE_NEW_POST');
export const USERS_GET = createAsyncActionType('users', 'USERS_GET');
export const USERS_POST = createAsyncActionType('users', 'USERS_POST');
export const USER_NOTIFICATIONS_GET = createAsyncActionType('users', 'USER_NOTIFICATIONS_GET');
export const USER_NOTIFICATIONS_READ = createAsyncActionType('users', 'USER_NOTIFICATIONS_READ');
export const USERS_SET_FILTER = '@@users/USERS_SET_FILTER';

/* Notifications */

export const NOTIFICATION_DELETE = createAsyncActionType('notifications', 'NOTIFICATION_DELETE');

/* Advisor Clients Actions */

export const CLIENTS_GET = createAsyncActionType('users', 'CLIENTS_GET');
export const CLIENTS_SET_FILTER = '@@users/CLIENTS_SET_FILTER';
export const CLIENT_CREATE_NEW_POST = createAsyncActionType('users', 'CLIENT_CREATE_NEW_POST');

/* Profile */

export const PROFILE_INFO_SAVE = createAsyncActionType('profile', 'PROFILE_INFO_SAVE');
export const PROFILE_ADDRESSES_GET = createAsyncActionType('profile', 'PROFILE_ADDRESSES_GET');
export const PROFILE_ADDRESS_SAVE = createAsyncActionType('profile', 'PROFILE_ADDRESSES_SAVE');
export const PROFILE_ADDRESS_DELETE = createAsyncActionType('profile', 'PROFILE_ADDRESS_DELETE');
export const PROFILE_DOCUMENTS_GET = createAsyncActionType('profile', 'PROFILE_DOCUMENTS_GET');
export const PROFILE_DOC_SAVE = createAsyncActionType('profile', 'PROFILE_DOC_SAVE');
export const PROFILE_DOC_DELETE = createAsyncActionType('profile', 'PROFILE_DOC_DELETE');
export const PROFILE_DOC_FILES_GET = createAsyncActionType('profile', 'PROFILE_DOC_FILES_GET');
export const PROFILE_DOC_FILE_UPLOAD = createAsyncActionType('profile', 'PROFILE_DOC_FILE_UPLOAD');
export const PROFILE_PIN_SAVE = createAsyncActionType('users', 'USER_PIN_SAVE');

/* Users */

export const USER_GET = createAsyncActionType('users', 'USER_GET');
export const USER_PATCH = createAsyncActionType('users', 'USER_PATCH');
export const USER_ADDRESSES_GET = createAsyncActionType('users', 'USER_ADDRESSES_GET');
export const USER_ADDRESSES_DELETE = createAsyncActionType('users', 'USER_ADDRESSES_DELETE');
export const USER_ADDRESSES_POST = createAsyncActionType('users', 'USER_ADDRESSES_POST');
export const USER_ADDRESSES_PATCH = createAsyncActionType('users', 'USER_ADDRESSES_PATCH');
export const USER_DOCUMENTS_GET = createAsyncActionType('users', 'USER_DOCUMENTS_GET');
export const USER_DOCUMENTS_DELETE = createAsyncActionType('users', 'USER_DOCUMENTS_DELETE');
export const USER_DOCUMENTS_POST = createAsyncActionType('users', 'USER_DOCUMENTS_POST');
export const USER_DOCUMENTS_PATCH = createAsyncActionType('users', 'USER_DOCUMENTS_PATCH');
export const USER_PROFILE_IMAGE_GET = createAsyncActionType('users', 'USER_PROFILE_IMAGE_GET');
export const USER_PROFILE_IMAGE_POST = createAsyncActionType('users', 'USER_PROFILE_IMAGE_POST');
export const USER_PROFILE_IMAGE_DELETE = createAsyncActionType('users', 'USER_PROFILE_IMAGE_DELETE');
export const USER_DETAILS_PATCH = createAsyncActionType('users', 'USER_DETAILS_PATCH');
export const USER_MAIN_CONTACTS_PATCH = createAsyncActionType('users', 'USER_MAIN_CONTACTS_PATCH');
export const USER_MAIN_CONTACTS_PATCH_OTP = createAsyncActionType('users', 'USER_MAIN_CONTACTS_PATCH_OTP');

/* Address */

export const ADDRESSES_GET = createAsyncActionType('address', 'ADDRESSES_GET');

/* Docs */

export const DOCUMENTS_GET = createAsyncActionType('documents', 'DOCUMENTS_GET');
export const DOCUMENT_FILE_GET = createAsyncActionType('documents', 'DOCUMENT_FILE_GET');
export const DOCUMENT_FILES_GET = createAsyncActionType('documents', 'DOCUMENT_FILES_GET');
export const DOCUMENT_FILES_POST = createAsyncActionType('documents', 'DOCUMENT_FILE_POST');

/* Client */

export const RISK_PROFILES_SIMULATION = createAsyncActionType('client', 'RISK_PROFILES_SIMULATION');
export const TOTAL_WEALTH_PROFILE_SIMULATION = createAsyncActionType('client', 'TOTAL_WEALTH_PROFILE_SIMULATION');
export const CLIENT_ADVISORS_GET = createAsyncActionType('client', 'CLIENT_ADVISORS_GET');
export const CLIENT_DASHBOARD_GET = createAsyncActionType('client', 'CLIENT_DASHBOARD_GET');
export const CLIENT_DETAILS_GET = createAsyncActionType('client', 'CLIENT_DETAILS_GET');
export const CLIENT_ACCOUNTS_GET = createAsyncActionType('client', 'CLIENT_ACCOUNTS_GET');
export const CLIENT_DETAILS_PATCH = createAsyncActionType('client', 'CLIENT_DETAILS_PATCH');
export const CLIENT_ASSETS_BREAKDOWN_GET = createAsyncActionType('client', 'CLIENT_ASSETS_BREAKDOWN_GET');

/* Financial Advisor */

export const FINANCIAL_ADVISOR_DASHBOARD_GET = createAsyncActionType('financialAdvisor', 'FINANCIAL_ADVISOR_DASHBOARD_GET');
export const FINANCIAL_ADVISOR_INVITE_LINK_POST = createAsyncActionType('financialAdvisor', 'FINANCIAL_ADVISOR_INVITE_LINK_POST');
export const CLIENT_DASHBOARD_AS_ADVISOR_GET = createAsyncActionType('financialAdvisor', 'CLIENT_DASHBOARD_AS_ADVISOR_GET');

/* Accounts */

export const ACCOUNTS_SET_FILTER = '@@accounts/ACCOUNTS_SET_FILTER';
export const ACCOUNTS_GET = createAsyncActionType('accounts', 'ACCOUNTS_GET');
export const ACCOUNTS_POST = createAsyncActionType('accounts', 'ACCOUNTS_POST');
export const ACCOUNT_GET = createAsyncActionType('accounts', 'ACCOUNT_GET');
export const ACCOUNT_PROFILE_STEP_3_SET = createAsyncActionType('account', 'ACCOUNT_PROFILE_STEP_3_SET');
export const ACCOUNT_PROFILE_STEPS_GET = createAsyncActionType('account', 'ACCOUNT_PROFILE_STEPS_GET');
export const ACCOUNT_RISK_PROFILE_RELOAD_ALL = '@@accounts/ACCOUNT_RISK_PROFILE_RELOAD_ALL';
export const ACCOUNT_RISK_APPETITE_PROFILES_GET = createAsyncActionType('account', 'ACCOUNT_RISK_APPETITE_PROFILES_GET');
export const ACCOUNT_RISK_APPETITE_PROFILES_POST_PATCH = createAsyncActionType('account', 'ACCOUNT_RISK_APPETITE_PROFILES_POST_PATCH');
export const ACCOUNT_RISK_APPETITE_PROFILES_SET = createAsyncActionType('account', 'ACCOUNT_RISK_APPETITE_PROFILES_SET');
export const ACCOUNT_ACCEPT_MIFID_PROFILE = createAsyncActionType('accounts', 'ACCOUNT_ACCEPT_MIFID_PROFILE');
export const ACCOUNT_RISK_PROFILE_POST = createAsyncActionType('accounts', 'ACCOUNT_RISK_PROFILE_POST');
export const ACCOUNT_SIMULATE_RISK_PROFILE = createAsyncActionType('accounts', 'ACCOUNT_SIMULATE_RISK_PROFILE');
export const ACCOUNT_MIFID_PROFILE_POST = createAsyncActionType('accounts', 'ACCOUNT_MIFID_PROFILE_POST');
export const ACCOUNT_SIGN_CONTRACT_POST = createAsyncActionType('accounts', 'ACCOUNT_SIGN_CONTRACT_POST');
export const ACCOUNT_FINANCIAL_ASSETS_GET = createAsyncActionType('accounts', 'ACCOUNT_FINANCIAL_ASSETS_GET');
export const ACCOUNT_FINANCIAL_ASSETS_POST_PATCH = createAsyncActionType('accounts', 'ACCOUNT_FINANCIAL_ASSETS_POST_PATCH');
export const ACCOUNT_LIFESTYLE_COSTS_GET = createAsyncActionType('accounts', 'ACCOUNT_LIFESTYLE_COSTS_GET');
export const ACCOUNT_LIFESTYLE_COSTS_POST_PATCH = createAsyncActionType('accounts', 'ACCOUNT_LIFESTYLE_COSTS_POST_PATCH');
export const ACCOUNT_FINANCIAL_EXPERIENCES_SET = createAsyncActionType('accounts', 'ACCOUNT_FINANCIAL_EXPERIENCES_SET');
export const ACCOUNT_FINANCIAL_EXPERIENCES_GET = createAsyncActionType('accounts', 'ACCOUNT_FINANCIAL_EXPERIENCES_GET');
export const ACCOUNT_FINANCIAL_EXPERIENCES_POST_PATCH = createAsyncActionType('accounts', 'ACCOUNT_FINANCIAL_EXPERIENCES_POST_PATCH');
export const ACCOUNT_INVESTMENT_OBJECTIVES_GET = createAsyncActionType('accounts', 'ACCOUNT_INVESTMENT_OBJECTIVES_GET');
export const ACCOUNT_INVESTMENT_OBJECTIVES_POST_PATCH = createAsyncActionType('accounts', 'ACCOUNT_INVESTMENT_OBJECTIVES_POST_PATCH');
export const ACCOUNT_TOTAL_WEALTH_CHART_GET = createAsyncActionType('accounts', 'ACCOUNT_TOTAL_WEALTH_CHART_GET');
export const ACCOUNT_OWNERS_GET = createAsyncActionType('accounts', 'ACCOUNT_OWNERS_GET');
export const ACCOUNT_OWNERS_PATCH = createAsyncActionType('accounts', 'ACCOUNT_OWNERS_PATCH');
export const ACCOUNT_INVESTMENT_AGREEMENTS_GET = createAsyncActionType('accounts', 'ACCOUNT_INVESTMENT_AGREEMENTS_GET');
export const ACCOUNT_INVESTMENT_AGREEMENTS_POST = createAsyncActionType('accounts', 'ACCOUNT_INVESTMENT_AGREEMENTS_POST');
export const ACCOUNT_INVESTMENT_AGREEMENTS_POST_OTP = createAsyncActionType('accounts', 'ACCOUNT_INVESTMENT_AGREEMENTS_POST_OTP');
export const ACCOUNT_SIGNED_INVESTMENT_AGREEMENTS_GET = createAsyncActionType('accounts', 'ACCOUNT_SIGNED_INVESTMENT_AGREEMENTS_GET');
export const ACCOUNT_AML_PROFILES_GET = createAsyncActionType('accounts', 'ACCOUNT_AML_PROFILES_GET');
export const ACCOUNT_AML_PROFILES_POST_PATCH = createAsyncActionType('accounts', 'ACCOUNT_AML_PROFILES_POST_PATCH');
export const ACCOUNT_TAX_SCHEMES_GET = createAsyncActionType('accounts', 'ACCOUNT_TAX_SCHEMES_GET');
export const ACCOUNT_TAX_SCHEMES_POST_PATCH = createAsyncActionType('accounts', 'ACCOUNT_TAX_SCHEMES_POST_PATCH');
export const ACCOUNT_CONFIRM_INFO = createAsyncActionType('accounts', 'ACCOUNT_CONFIRM_INFO');
export const ACCOUNT_CONTRACTS_GET = createAsyncActionType('accounts', 'ACCOUNT_CONTRACTS_GET');
export const ACCOUNT_CONTRACTS_POLLING_GET = createAsyncActionType('accounts', 'ACCOUNT_CONTRACTS_POLLING_GET');
export const ACCOUNT_CONTRACTS_SIGN_POST_OTP = createAsyncActionType('accounts', 'ACCOUNT_CONTRACTS_SIGN_POST_OTP');

/* Wallets */

export const PORTFOLIO_WALLETS_GET = createAsyncActionType('wallets', 'PORTFOLIO_WALLETS_GET');
export const WALLETS_TRANSACTIONS_GET = createAsyncActionType('wallets', 'WALLETS_TRANSACTIONS_GET');
export const WALLETS_WITH_TRANSACTIONS_GET = createAsyncActionType('wallets', 'WALLETS_WITH_TRANSACTIONS_GET');
export const WALLETS_TRANSACTIONS_POST = createAsyncActionType('wallets', 'WALLETS_TRANSACTIONS_POST');

/* Mandates */

export const MANDATES_GET = createAsyncActionType('mandates', 'MANDATES_GET');
export const MANDATES_POST = createAsyncActionType('mandates', 'MANDATES_POST');
export const MANDATES_PATCH = createAsyncActionType('mandates', 'MANDATES_PATCH');
export const MANDATES_HOLDINGS_GET = createAsyncActionType('mandates', 'MANDATES_HOLDINGS_GET');
export const MANDATES_DETAILS_GET = createAsyncActionType('mandates', 'MANDATES_DETAILS_GET');
export const MANDATES_KPIS_GET = createAsyncActionType('mandates', 'MANDATES_KPIS_GET');
export const MANDATES_PERFORMANCE_GET = createAsyncActionType('mandates', 'MANDATES_PERFORMANCE_GET');
export const MANDATES_HOLDINGS_POST = createAsyncActionType('mandates', 'MANDATES_HOLDINGS_POST');
export const MANDATES_HOLDINGS_PATCH = createAsyncActionType('mandates', 'MANDATES_HOLDINGS_PATCH');
export const MANDATES_IMPORT_QUOTES_POST = createAsyncActionType('mandates', 'MANDATES_IMPORT_QUOTES_POST');
export const MANDATES_MAX_DRAWDOWN_GET = createAsyncActionType('mandates', 'MANDATES_MAX_DRAWDOWN_GET');
export const MANDATES_OPTIMIZATION_GET = createAsyncActionType('mandates', 'MANDATES_OPTIMIZATION_GET');
export const MANDATES_ALERT = '@@mandates/MANDATES_ALERT';

/* Peer profiles */

export const PEER_PROFILES_GET = createAsyncActionType('peerProfiles', 'PEER_PROFILES_GET');
export const PEER_PROFILES_INSTRUMENTS_GET = createAsyncActionType('peerProfiles', 'PEER_PROFILES_INSTRUMENTS_GET');
export const PEER_PROFILES_SELECTED_INSTRUMENTS_GET = createAsyncActionType('peerProfiles', 'PEER_PROFILES_SELECTED_INSTRUMENTS_GET');

/* Preprocessing Fund Profiles */

export const PREPROCESSING_FUND_PROFILES_FUNDS_GET = createAsyncActionType('preprocessingFundProfiles', 'PREPROCESSING_FUND_PROFILES_FUNDS_GET');

/* Peer categories */

export const PEER_CATEGORIES_GET = createAsyncActionType('peerCategories', 'PEER_CATEGORIES_GET');
export const PEER_CATEGORIES_INSTRUMENTS_GET = createAsyncActionType('peerCategories', 'PEER_CATEGORIES_INSTRUMENTS_GET');

/* Model Portfolios */

export const MODEL_PORTFOLIOS_GET = createAsyncActionType('modelPortfolios', 'MODEL_PORTFOLIOS_GET');
export const MODEL_PORTFOLIOS_POST = createAsyncActionType('modelPortfolios', 'MODEL_PORTFOLIOS_POST');
export const MODEL_PORTFOLIOS_DELETE = createAsyncActionType('modelPortfolios', 'MODEL_PORTFOLIOS_DELETE');
export const MODEL_PORTFOLIOS_WITH_KPIS_GET = createAsyncActionType('modelPortfolios', 'MODEL_PORTFOLIOS_WITH_KPIS_GET');
export const MODEL_PORTFOLIOS_HOLDINGS_GET = createAsyncActionType('modelPortfolios', 'MODEL_PORTFOLIOS_HOLDINGS_GET');
export const MODEL_PORTFOLIOS_DETAILS_GET = createAsyncActionType('modelPortfolios', 'MODEL_PORTFOLIOS_DETAILS_GET');
export const MODEL_PORTFOLIOS_HOLDINGS_PATCH = createAsyncActionType('modelPortfolios', 'MODEL_PORTFOLIOS_HOLDINGS_PATCH');
export const MODEL_PORTFOLIOS_KPIS_GET = createAsyncActionType('modelPortfolios', 'MODEL_PORTFOLIOS_KPIS_GET');
export const MODEL_PORTFOLIOS_PERFORMANCES_GET = createAsyncActionType('modelPortfolios', 'MODEL_PORTFOLIOS_PERFORMANCES_GET');
export const MODEL_PORTFOLIOS_MAX_DRAWDOWN_GET = createAsyncActionType('modelPortfolios', 'MODEL_PORTFOLIOS_MAX_DRAWDOWN_GET');

/* Instruments */

export const INSTRUMENTS_PATCH = createAsyncActionType('instruments', 'INSTRUMENTS_PATCH');

/* AUMs */

export const AUMS_GET = createAsyncActionType('aums', 'AUMS_GET');
export const ACCOUNT_AUMS_GET = createAsyncActionType('accountAums', 'ACCOUNT_AUMS_GET');

/* Fees */

export const FEES_GET = createAsyncActionType('fees', 'FEES_GET');

/* Simulations */

export const SIMULATIONS_HOLDINGS_OPTIMIZATION = createAsyncActionType('simulations', 'SIMULATIONS_HOLDINGS_OPTIMIZATION');
export const SIMULATIONS_HOLDINGS_KPIS = createAsyncActionType('simulations', 'SIMULATIONS_HOLDINGS_KPIS');
export const SIMULATIONS_EXPECTED_FEES = createAsyncActionType('simulations', 'SIMULATIONS_EXPECTED_FEES');
export const SIMULATIONS_INVESTMENT_FORECAST = createAsyncActionType('simulations', 'SIMULATIONS_INVESTMENT_FORECAST');
export const SIMULATIONS_INVESTMENT_RECOMMENDATION = createAsyncActionType('simulations', 'SIMULATIONS_INVESTMENT_RECOMMENDATION');
export const SIMULATIONS_HOLDINGS_OPTIMIZATION_CLEAR = '@@simulations/SIMULATIONS_HOLDINGS_OPTIMIZATION_CLEAR';

/* Leads */

export const LEADS_GET = createAsyncActionType('leads', 'LEADS_GET');
export const LEADS_POST = createAsyncActionType('leads', 'LEADS_POST');
export const LEADS_PATCH = createAsyncActionType('leads', 'LEADS_PATCH');
export const LEADS_WARNING_MESSAGE = '@@leads/LEADS_WARNING_MESSAGE';

/* Tickets */

export const TICKETS_POST = createAsyncActionType('tickets', 'TICKETS_POST');

/* Instruments */

export const INSTRUMENTS_GET = createAsyncActionType('instruments', 'INSTRUMENTS_GET');
export const INSTRUMENTS_LIST_GET = createAsyncActionType('instruments', 'INSTRUMENTS_LIST_GET');
export const INSTRUMENTS_DETAILS_GET = createAsyncActionType('instruments', 'INSTRUMENTS_DETAILS_GET');
export const INSTRUMENTS_PERFORMANCE_GET = createAsyncActionType('instruments', 'INSTRUMENTS_PERFORMANCE_GET');
export const INSTRUMENTS_KPIS_GET = createAsyncActionType('instruments', 'INSTRUMENTS_KPIS_GET');

/* ETFs */

export const ETFS_LIST_GET = createAsyncActionType('instruments', 'ETFS_LIST_GET');
export const ETFS_BROAD_ASSET_CLASSES_GET = createAsyncActionType('instruments', 'ETFS_BROAD_ASSET_CLASSES_GET');
export const ETFS_BENCHMARK_INDICES_GET = createAsyncActionType('instruments', 'ETFS_BENCHMARK_INDICES_GET'); /* ETFs */

/* Funds */

export const FUNDS_LIST_GET = createAsyncActionType('instruments', 'FUNDS_LIST_GET');
export const FUNDS_BROAD_ASSET_CLASSES_GET = createAsyncActionType('instruments', 'FUNDS_BROAD_ASSET_CLASSES_GET');
export const FUNDS_BENCHMARK_INDICES_GET = createAsyncActionType('instruments', 'FUNDS_BENCHMARK_INDICES_GET');

/* Investment Objectives */

export const INVESTMENT_OBJECTIVES_PATCH = createAsyncActionType('investmentObjectives', 'INVESTMENT_OBJECTIVES_PATCH');
export const INVESTMENT_OBJECTIVES_CHANGE_REQUEST = createAsyncActionType('investmentObjectives', 'INVESTMENT_OBJECTIVES_CHANGE_REQUEST');
export const INVESTMENT_OBJECTIVE_GET = createAsyncActionType('investmentObjectives', 'INVESTMENT_OBJECTIVE_GET');
export const INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_GET = createAsyncActionType('investmentObjectives', 'INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_GET');
export const INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_POST = createAsyncActionType('investmentObjectives', 'INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_POST');
export const INVESTMENT_OBJECTIVE_PORTFOLIOS_GET = createAsyncActionType('investmentObjectives', 'INVESTMENT_OBJECTIVE_PORTFOLIOS_GET');

/* Portfolio Proposals */

export const PORTFOLIO_PROPOSALS_PATCH = createAsyncActionType('portfolioProposals', 'PORTFOLIO_PROPOSALS_PATCH');
export const PORTFOLIO_PROPOSALS_PUBLISH = createAsyncActionType('portfolioProposals', 'PORTFOLIO_PROPOSALS_PUBLISH');
export const PORTFOLIO_PROPOSALS_MULTIPLE_PUBLISH = createAsyncActionType('portfolioProposals', 'PORTFOLIO_PROPOSALS_MULTIPLE_PUBLISH');
export const PORTFOLIO_PROPOSALS_COPY = createAsyncActionType('portfolioProposals', 'PORTFOLIO_PROPOSALS_COPY');
export const PORTFOLIO_PROPOSALS_BENCHMARK_GET = createAsyncActionType('portfolioProposals', 'PORTFOLIO_PROPOSALS_BENCHMARK_GET');
export const PORTFOLIO_PROPOSALS_HOLDINGS_GET = createAsyncActionType('portfolioProposals', 'PORTFOLIO_PROPOSALS_HOLDINGS_GET');
export const PORTFOLIO_PROPOSALS_KPIS_GET = createAsyncActionType('portfolioProposals', 'PORTFOLIO_PROPOSALS_KPIS_GET');
export const PORTFOLIO_PROPOSALS_DETAILS_GET = createAsyncActionType('portfolioProposals', 'PORTFOLIO_PROPOSALS_DETAILS_GET');
export const PORTFOLIO_PROPOSALS_HOLDINGS_PATCH = createAsyncActionType('portfolioProposals', 'PORTFOLIO_PROPOSALS_HOLDINGS_PATCH');
export const PORTFOLIO_PROPOSALS_HOLDINGS_OPTIMIZATION = createAsyncActionType('portfolioProposals', 'PORTFOLIO_PROPOSALS_HOLDINGS_OPTIMIZATION');

/* Portfolios */
export const PORTFOLIOS_SET_FILTER = '@@portfolios/PORTFOLIOS_SET_FILTER';
export const PORTFOLIOS_GET = createAsyncActionType('portfolios', 'PORTFOLIOS_GET');
export const PORTFOLIO_PROPOSALS_MAX_DRAWDOWN_GET = createAsyncActionType('portfolios', 'PORTFOLIO_PROPOSALS_MAX_DRAWDOWN_GET');
export const PORTFOLIOS_BENCHMARK_GET = createAsyncActionType('portfolios', 'PORTFOLIOS_BENCHMARK_GET');
export const PORTFOLIOS_HOLDINGS_GET = createAsyncActionType('portfolios', 'PORTFOLIOS_HOLDINGS_GET');
export const PORTFOLIOS_KPIS_GET = createAsyncActionType('portfolios', 'PORTFOLIOS_KPIS_GET');
export const PORTFOLIOS_DETAILS_GET = createAsyncActionType('portfolios', 'PORTFOLIOS_DETAILS_GET');

/* Watchlists */
export const USER_WATCHLISTS_GET = createAsyncActionType('users', 'USER_WATCHLISTS_GET');
export const USER_WATCHLISTS_POST = createAsyncActionType('users', 'USER_WATCHLISTS_POST');
export const USER_WATCHLISTS_INSTRUMENTS_GET = createAsyncActionType('users', 'USER_WATCHLISTS_INSTRUMENTS_GET');

export const WATCHLISTS_GET = createAsyncActionType('watchlists', 'WATCHLISTS_GET');
export const WATCHLISTS_DELETE = createAsyncActionType('watchlists', 'WATCHLISTS_DELETE');
export const WATCHLISTS_PATCH = createAsyncActionType('watchlists', 'WATCHLISTS_PATCH');
export const WATCHLISTS_MANAGER = createAsyncActionType('watchlists', 'WATCHLISTS_MANAGER');
export const WATCHLISTS_INSTRUMENTS_GET = createAsyncActionType('watchlists', 'WATCHLISTS_INSTRUMENTS_GET');
export const WATCHLISTS_INSTRUMENTS_DELETE = createAsyncActionType('watchlists', 'WATCHLISTS_INSTRUMENTS_DELETE');
export const WATCHLISTS_INSTRUMENTS_POST = createAsyncActionType('watchlists', 'WATCHLISTS_INSTRUMENTS_POST');

/* Meetings */
export const USER_MEETINGS_GET = createAsyncActionType('users', 'USER_MEETINGS_GET');
export const USER_MEETING_TYPES_GET = createAsyncActionType('users', 'USER_MEETING_TYPES_GET');
export const MEETING_INVITEES_GET = createAsyncActionType('meetings', 'MEETING_INVITEES_GET');

/* Account Documents */
export const ACCOUNT_DOCUMENTS_GET = createAsyncActionType('accounts', 'ACCOUNT_DOCUMENTS_GET');
export const ACCOUNT_DOCUMENTS_POST = createAsyncActionType('accounts', 'ACCOUNT_DOCUMENTS_POST');
